import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(public)/informacoes/informacoes-client.tsx");
